export function getDebugEnv() {
  return Object.fromEntries(
    Object.entries(import.meta.env)
      .sort(([leftKey], [rightKey]) => leftKey.localeCompare(rightKey))
      .map(([key, value]) => [key, value]),
  );
}
